import { BaseModal } from './BaseModal'
import { ModalFooter } from './ModalFooter'
import type { ModalProps } from './types'

export const Modal = (p: ModalProps) => <BaseModal {...p} />

Modal.Footer = ModalFooter
